import { collection, query, where, onSnapshot } from "firebase/firestore";
import { firestore } from "../../../services/firebase";

export const getCardsForCardFeeByBranch = (branchId, callback) => {
  try {
    const cardsRef = collection(firestore, "Card");
    const q = query(
      cardsRef,
      where("branchId", "==", branchId + " normal"),
      where("status", "==", "Completed"),
      where("cardFeeStatus", "==", "PendingCharge")
    );

    return onSnapshot(q, (querySnapshot) => {
      const cards = [];
      querySnapshot.forEach((doc) => {
        cards.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      callback(cards);
    });
  } catch (error) {
    console.error("Error in getCardsForCardFeeByBranch:", error);
    throw error;
  }
};
